module.exports = __webpack_public_path__ + "img/img07.b88495da.png";